<template>
  <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="close">
    <v-card>
      <v-card-title>
        <div class="d-flex flex-row align-start">
          <v-icon color="error" left class="pl-0 pt-1 ml-0">mdi-alert-circle</v-icon>
          <div>{{ trans('error.general') }}</div>
        </div>
      </v-card-title>
      <v-card-text>
        <slot>
          <template v-if="!!message">
            {{ message }}
          </template>
        </slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="close">Okay</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';

export default {
  name: 'ErrorDialog',
  mixins: [
    LocaleUtils
  ],
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    options: {
      color: 'error',
      width: 450,
      zIndex: 200
    }
  }),
  methods: {
    open (message, options) {
      this.dialog = true
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    close () {
      this.resolve(true)
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
